import { Organization } from "../../../core/models/entities/Organization";
import { User } from "../../../core/models/entities/User";
import { Manufacturer } from "../../../core/models/entities/Manufacturer";
import { useRepositoriesContext } from "../../../contexts/RepositoriesContext";
import { CreateUserDto } from "../../../core/models/dtos/CreateUserDto";
import { OrganizationDetailsView_VM } from "../../components/Organization/organization-details-view.component";
import { useNavigate } from "react-router-dom";
import { PageQuery, toInAppQueryParam } from "../../../utils/models/pageQuery";
import { useState } from "react";
import { withToasts } from "../../components/Toast/Toast";
import { useTranslation } from "react-i18next";

export function useOrganizationDetailsViewCustomer(
  organization: Organization
): OrganizationDetailsView_VM {
  const { t } = useTranslation();
  const { manufacturerRepository } = useRepositoriesContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const {
    data: manufacturers,
    isLoading: isManufacturersLoading,
    isError: isManufacturersError,
  } = manufacturerRepository.useManufacturers();

  function handleBranchClick(branch: Organization) {
    navigate(`/vendor/${branch.id}`);
  }

  function handleToMainBranch() {
    navigate(`/vendor/${organization.mainBranchId}`);
  }

  function handleToCustomers() {
    const page = {
      page: {
        index: 1,
        size: 25,
      },
      filterBy: [
        {
          field: "parent.id",
          value: "" + organization.id,
        },
      ],
    } as PageQuery;
    const s = toInAppQueryParam(page);
    navigate(`/customer${s}`);
  }

  function handleToEdit() {
    navigate(`edit`);
  }

  const subject = t("customer");
  return {
    subject,
    organization,
    manufacturers: manufacturers || [],
    onBranchClick: handleBranchClick,
    onToMainBranch: handleToMainBranch,
    onToCustomers: handleToCustomers,
    onToEdit: handleToEdit,
  };
}
